import { render, staticRenderFns } from "./groupOfCharges.vue?vue&type=template&id=0586c052"
import script from "./groupOfCharges.vue?vue&type=script&lang=js"
export * from "./groupOfCharges.vue?vue&type=script&lang=js"
import style0 from "./groupOfCharges.vue?vue&type=style&index=0&id=0586c052&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports